import { render, staticRenderFns } from "./LandingPlans.vue?vue&type=template&id=58319f0a&scoped=true"
import script from "./LandingPlans.vue?vue&type=script&lang=js"
export * from "./LandingPlans.vue?vue&type=script&lang=js"
import style0 from "./LandingPlans.vue?vue&type=style&index=0&id=58319f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58319f0a",
  null
  
)

export default component.exports